import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from 'moment';
import { Environment } from '../../../shared/environment';
import { IgetImpressaoNota } from '../../../shared/services/api/vendas/pedidonota/PedidoNota';

async function PDFPedidoLider(dados: IgetImpressaoNota) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const TProdutos = dados.itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
  const Ttotal = dados.itens.reduce((acc, item) => acc + (item.total || 0), 0);
  const TRegistros = dados.itens.length;

  const rows = dados.itens.map((row) => {
    return [
      { text: row.codfabrica, fontSize: 8, border: [false, false, false, true]  },
      { text: row.descricao, fontSize: 8, border: [false, false, false, true]  },
      { text: row.un, border: [false, false, false, true]  },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade),
        alignment: 'right',  bold: true, border: [false, false, false, true], fontSize: 9
      },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.preco),
        alignment: 'right', bold: true, border: [false, false, false, true], fontSize: 9
      },
      {
        text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.total),
        alignment: 'right',  bold: true, border: [false, false, false, true], fontSize: 9
      },
    ]
    
  });

  const documentDefinition: any = {

    content: [
      { text: 'LIDER SEMIJOIAS LTDA', fontSize: 12, bold: true, alignment: 'center' },
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [70, 110, 80, 70, 70, 74],
          body: [
            [   
              { text: 'PEDIDO', fontSize: 8, bold: true },
              { text: dados.numero, colSpan: 3, fontSize: 9, border: [true, true, false, true] },
              { text: '', fontSize: 8, bold: true,  border: [false, false, false, false] },
              { text: '', fontSize: 8, bold: true,  border: [false, false, false, false] },
              { text: 'DATA PEDIDO', fontSize: 8, bold: true,  border: [false, true, false, true] },
              { text: moment(dados.dataoperacao).format('DD/MM/YYYY'), fontSize: 9 },
            ],
            [       
              { text: 'CLIENTE',  fontSize: 8, bold: true },
              { text: dados.nome, colSpan: 5, fontSize: 9},
              { text: '', fontSize: 8, border: [false, false, false, false] },   
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
            [   
              { text: 'ENDEREÇO', fontSize: 8, bold: true },
              { text: dados.endereco, colSpan: 5, fontSize: 9},
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
            [   
              { text: '', fontSize: 8, bold: true },
              { text: dados.municipio+' - '+dados.uf+' - '+dados.cep, colSpan: 5, fontSize: 9},
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
            [   
              { text: 'APELIDO', fontSize: 8, bold: true },
              { text: dados.fantasia, colSpan: 3, fontSize: 9, border: [true, true, false, true] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: 'TELEFONE', fontSize: 8, border: [false, true, true, true]},
              { text: dados.celular, fontSize: 8},
            ],
            [   
              { text: 'REPRESENTANTE', fontSize: 8, bold: true },
              { text: '000018  CLAUDIO',  colSpan: 5, fontSize: 9},
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
            [   
              { text: 'NOME COMPL', fontSize: 8, bold: true },
              { text: '',  colSpan: 5, fontSize: 9},
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
              { text: '', fontSize: 8, border: [false, false, false, false] },
            ],
          ],
        }
      },    
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [50, 200, 30, 54, 70, 70],
          body: [
            [
              { text: 'Produto',  fontSize: 9, border: [false, false, false, true] },
              { text: 'Descrião', fontSize: 9, border: [false, false, false, true] },
              { text: 'Un', alignment: 'center',  fontSize: 9, border: [false, false, false, true] },
              { text: 'Qtde', alignment: 'right',  fontSize: 9, border: [false, false, false, true] },
              { text: 'Unitário', alignment: 'right',  fontSize: 9, border: [false, false, false, true] },
              { text: 'Total', alignment: 'right', fontSize: 9, border: [false, false, false, true] },
            ],
            ...rows,
          ]
        },
      },  
      {
        
        table: {
          widths: [50, 200, 30, 54, 70, 70],
          body: [
            [
              { text: TRegistros+ '   itens', alignment: 'right',  fontSize: 9, border: [false, false, false, true] },
              { text: 'Qtde Total de Produtos', colSpan: 2, alignment: 'right', fontSize: 9, border: [false, false, false, true] },
              { text: '', alignment: 'center',  fontSize: 9, border: [false, false, false, true] },
              { text:  new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TProdutos), alignment: 'right',  fontSize: 9, border: [false, false, false, true] },
              { text: '', alignment: 'right',  fontSize: 9, border: [false, false, false, true] },
              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal), alignment: 'right', fontSize: 9, border: [false, false, false, true] },
            ],
          ]
        },
      },    
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [320, 180],
          body: [
            [
              { 
                 margin: [0, 80, 0, 0],
                  table: {
                    widths: [80, 50, 60],
                    body: [
                      [
                        { text: 'Cond Pagto:', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                        { text: '30 dias', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                        { text: '', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      ],
                      [
                        { text: 'Documento', alignment: 'left', fontSize: 9, border: [false, false, false, false] },
                        { text: 'Data Vencto', alignment: 'left',   fontSize: 9, border: [false, false, false, false] },
                        { text: 'Valor', alignment: 'right',  fontSize: 9, border: [false, false, false, false] },
                      ],
                      [
                        { text: '', alignment: 'left',  fontSize: 9, border: [false, true, false, false] },
                        { text: '', alignment: 'left',  fontSize: 9, border: [false, true, false, false] },
                        { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal),
                          alignment: 'right', fontSize: 9, border: [false, true, false, false] },
                      ],
                    ]
                  },
                  border: [false, false, false, false]
                },       
              { table: {
                  widths: [80, 80],
                  body: [
                    [
                      { text: 'Valor Bruto', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal),
                       alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Descto 1', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0),
                       alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Descto 2', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0), 
                      alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Descto Vista', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0), 
                      alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Comissão', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0),
                       alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Devolução', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0), 
                      alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Transporte', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(0), 
                      alignment: 'right', fontSize: 9, border: [false, false, false, false] },
                    ],
                    [
                      { text: 'Valor Total', alignment: 'left',  fontSize: 9, border: [false, false, false, false] },
                      { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal),
                       alignment: 'right', fontSize: 9, border: [false, true, false, false] },
                    ],
                  ]
                },
              },
            ],
          ]
        },
      },   
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [280, 230],
          body: [
            [
              { text: 'Recebi (emos) o(s) produtos(s) acima,', alignment: 'left',  fontSize: 9, border: [false, true, false, false] },
              { text: '', alignment: 'left',  fontSize: 9, border: [false, true, false, false] },
            ],
            [
              { text: 'Data recebimento: ___/_____/_____', alignment: 'left', margin: [0, 5, 0, 0], fontSize: 9, border: [false, false, false, false] },
              { text: 'Assinatura:_________________________________________', alignment: 'left', margin: [0, 5, 0, 0],  fontSize: 9, border: [false, false, false, false] },
            ],
          ]
        },
      },       
    ],
  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default PDFPedidoLider;